// extracted by mini-css-extract-plugin
module.exports = {"QuestionWrapper":"QuestionLayer_QuestionWrapper__Wl_g5","Title":"QuestionLayer_Title__Fpyyr","Content":"QuestionLayer_Content__US0Tx"};